import type { SearchPosting } from "@/lib/api/catalogue";
import type { Application } from "@/lib/api/envoy";
import { statusGroup } from "./statusGroup";
import { JOBS_STATUS_LABEL, type JobsStatus } from "./view";

export { statusGroup } from "./statusGroup";

/** How many of these results fall under each status filter. */
export function statusCounts(
    postings: readonly SearchPosting[],
    applications: Record<string, Application> | undefined,
): Record<JobsStatus, number> {
    const counts: Record<JobsStatus, number> = {
        all: postings.length,
        queue: 0,
        applied: 0,
        open: 0,
    };
    return postings.reduce((tally, posting) => {
        const group = statusGroup(applications?.[posting.posting_id]);
        return group === "closed" ? tally : { ...tally, [group]: tally[group] + 1 };
    }, counts);
}

/** Whether a result shows under the status filter picked. */
export function keepsStatus(status: JobsStatus, application: Application | undefined): boolean {
    return status === "all" || statusGroup(application) === status;
}

/** The results the status filter keeps. */
export function shownPostings<Shown extends SearchPosting>(
    postings: readonly Shown[],
    status: JobsStatus,
    applications: Readonly<Record<string, Application>> | undefined,
): Shown[] {
    return postings.filter((posting) => keepsStatus(status, applications?.[posting.posting_id]));
}

/** The line in place of the results when none shows. */
export function emptyLine(found: number, status: JobsStatus): string {
    return found === 0
        ? "Nothing open matches. Try fewer words, or clear a filter."
        : `Nothing on this page is ${JOBS_STATUS_LABEL[status].toLowerCase()}.`;
}
